import { useMyDataContext } from "@/hooks/context/useMyDataContext";
import { Loader2 } from "lucide-react";

export const CancelView = () => {
  const { data, isLoading } = useMyDataContext();
  const { given_name, surname } = data || { given_name: "", surname: "" };
  return (
    <div className="bg-transparent rounded-lg  p-8 text-center" dir="rtl">
      {/* Main Title */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">ניתוק משירות קבלת מיילים</h1>
        <div className="w-16 h-1 bg-red-400 mx-auto rounded-full"></div>
      </div>

      {/* Personal Greeting */}
      {isLoading ? (
        <div className="flex flex-col items-center justify-center">
          <Loader2 className="h-16 w-16 text-[#b65bf3] animate-spin" />
          <p className="text-lg mt-4 text-zoooz-primary">טוען נתונים...</p>
        </div>
      ) : (
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            שלום {given_name + " " + surname || "משתמש יקר"}
          </h2>
        </div>
      )}

      {/* Warning Message */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-8">
        <div className="flex items-center justify-center mb-4">
          <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
        </div>
        <p className="text-amber-800 leading-relaxed text-lg">
          ביטול שירות קבלת מיילים ימנע ממך מלקבל עדכונים חמים עבור הזדמנויות חדשות ועדכונים חשובים אשר יכולים להועיל
          לעמותה.
        </p>
      </div>

      {/* What you'll miss section */}
      <div className="text-right mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">מה תפסיד:</h3>
        <ul className="space-y-3 text-gray-600">
          <li className="flex items-center gap-3">
            <div className="w-2 h-2 bg-red-400 rounded-full flex-shrink-0"></div>
            <span>עדכונים על הזדמנויות תרומה חדשות</span>
          </li>
          <li className="flex items-center gap-3">
            <div className="w-2 h-2 bg-red-400 rounded-full flex-shrink-0"></div>
            <span>מידע חשוב על שינויים במערכת</span>
          </li>
          <li className="flex items-center gap-3">
            <div className="w-2 h-2 bg-red-400 rounded-full flex-shrink-0"></div>
            <span>טיפים ועצות לגיוס תרומות יעיל</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CancelView;
